import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { SButton } from '@strana-artw/ui-kit';
import ErrorUnavailablePage from '@/app/ui/ErrorUnavailablePage.vue';
import { useAuthStore } from '@/store/authStore';
var unavailablePageErrorsCodeSet = new Set([500, 503, 502, 408, 504, 522, 501, 505, 510, 511, 400, 405, 406, 409, 411, 412, 413, 414, 415, 416, 417, 401, 403, 407]);
export default {
  components: {
    SButton: SButton,
    ErrorUnavailablePage: ErrorUnavailablePage
  },
  layout: function layout() {
    var userStore = useAuthStore();
    return userStore.loggedIn ? 'default' : 'LayoutLanding';
  },
  props: {
    error: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    errorTitle: function errorTitle() {
      return this.error.statusCode;
    },
    errorText: function errorText() {
      var code = this.error.statusCode;
      return code === 404 ? 'Такой страницы не существует или мы ее еще не построили...' : '';
    },
    isUnavailablePage: function isUnavailablePage() {
      return unavailablePageErrorsCodeSet.has(this.error.statusCode);
    }
  }
};